// extracted by mini-css-extract-plugin
module.exports = {"custom_row":"style_custom_row__3cW_3","dao_name":"style_dao_name__3h16M"};